import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class QuestionStatistic extends Model<Schemas['questionStatistics'], Models> {}
